<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="cancellations">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>Box connectées</h1>
				</div>
			</div>

			
			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">

					<h4>{{ onlineboxes_total }} box connectées | {{incidentCount}} problèmes</h4>

					<!--div class="d-flex justify-content-end align-items-start mb-3" style="margin-top: -60px">
						<m-form-select
							:width="300"
							label="Filter par statut"
							label-position="top"
							:name="$Utils.randomstring('filterStatus')"
							v-model="filterStatus"
							:items="$store.state.items_cr_statuses"
							@input="loadCancellations"
						/>
						<m-form-text
							class="ml-3"
							label="Rechercher"
							label-position="top"
							v-model="filterText"
							name="search"
							autocomplete
							@input="loadCancellations"
						/>
					</div-->


					<m-list
						ref="onlineboxeslist"
						:dynamic="true"
						:items="onlineboxes"
						item-value="or_id"
						:item-height="30"
						:limit="onlineboxes_limit"
						:skip="onlineboxes_skip"
						:total="onlineboxes_total"
						:bgstrip="false"
						@itemclick="goBox"
					>
						<template v-slot:ths="{}">
							<th style="width: 60px;">
								#
							</th>
							<th>
								Etablissement
							</th>
							<th>
								Contact
							</th>
							<th>
								Bénéficiaire
							</th>
							<th style="width: 80px;">
								Box ver.
							</th>
							<th class="text-center">
								Abonnement
							</th>
							<th class="text-center">
								Paiement
							</th>
						</template>
						<template v-slot:tds="{ item }">
							<td :class="getBoxBackground(item)" style="width: 60px;">
								{{ item.en_id }}
							</td>
							<td :class="getBoxBackground(item)">
								{{ item.es_name }}
							</td>
							<td :class="getBoxBackground(item)">
								{{ item.co_invoice_firstname }} {{ item.co_invoice_name }}
							</td>
							<td :class="getBoxBackground(item)">
								{{ item.en_fullname }}
							</td>
							<td :class="getBoxBackground(item)" style="width: 80px;">
								{{ item.bo_hardwareinfo.appemotivi_version }}
							</td>
							<td :class="`${getBoxBackground(item)} text-center`">
								<div
									class="indicatorLight"
									:class="{
										isActive: item.su_state === 2,
										isStopping: item.su_state === 1,
										isStopped: item.su_state === 0
									}"
								>
									{{ item.su_state !== null ? "A" : null }}
								</div>
							</td>
							<td :class="`${getBoxBackground(item)} text-center`">

								<div
									class="indicatorLight"
									:class="{
										notExists: item.su_remote_status === 'trialing',
										isActive: item.su_remote_status === 'active',
										isStopping: item.su_remote_status === 'problem',
										isStopped: item.su_remote_status === 'cancelled'
									}"
									:title="`#${item.su_id}: ${item.su_remote_raw_status}`"
								>
									{{ item.su_gocardlessid ? "G" : (item.su_stripeid ? "S" : null) }}
								</div>
							</td>
						</template>
					</m-list>
						
				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: "onlineboxes",
  components: { },
  data() {
    return {

      onlineboxes: [],
      onlineboxes_total: 0,
      onlineboxes_limit: 50,
      onlineboxes_skip: 0,
      sortOrder: "asc",
      sortFields: [],
      row_en: {},
      filterText: "",
      filterStatus: "",
      itemSelected: {},
      dialog: false,
    };
  },

  watch: {

  },

  async mounted() {

    let id = parseInt(this.$route.params.or_id);

    if (id) {
      this.itemSelected.cr_id = id;
      this.dialog = true;
    }

    this.loadOnlineBoxes();

  },
  computed: {
  
	incidentCount() {
		let count = 0;
		this.onlineboxes.forEach(box => {
			const hasPaymentIncident = box.su_state !== null && !(box.su_remote_status === "active" || box.su_remote_status === "trialing");
			const hasSubscription = box.es_name === "Emotivi" && box.su_state === null;
			if(hasPaymentIncident || hasSubscription) {
				count++
			}
		});
		return count;
	}

  },
  methods: {

    goBox(data) {
      this.$store.commit("set_scrollPosition", this.$refs.onlineboxeslist.scrollTop);
      this.$router.push("/boxes/" + data.en_id);
    },

	getBoxBackground(data) {
		const hasPaymentIncident = data.su_state !== null && !(data.su_remote_status === "active" || data.su_remote_status === "trialing");
		const hasSubscription = data.es_name === "Emotivi" && data.su_state === null;
		if(hasPaymentIncident || hasSubscription) {
			return "warning";
		}
		return "";
	},

    onlineBoxesChangeRange(skip) {
		this.onlineboxes_skip = skip;
		this.loadOnlineBoxes();
    },

    sortItems(fields) {
      if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = fields;
      this.loadOnlineBoxes();
    },

    async loadOnlineBoxes() {

		let params = {
			skip: this.onlineboxes_skip,
			limit: this.onlineboxes_limit
		};

		/*
		if(this.filterText){
			params.search = this.filterText;
		}

		if(this.filterStatus){
			params.status = this.filterStatus;
		}
		*/

		this.cancelAxiosLoadOnlineBoxes && this.cancelAxiosLoadOnlineBoxes();

		let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/endusers/connected`, {
			params,
			cancelToken: new this.$axios.CancelToken(c => {
				this.cancelAxiosLoadOnlineBoxes = c;
			})
		});

		if(!response || !response.data){
			return;
		}

		this.onlineboxes = response.data.data;
		this.onlineboxes_total = response.data.data.length;
    },

    editOnlineBoxes(item) {
      this.itemSelected = item;
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";

.label-new {
	position: absolute;
	right: -6px;
	top: 0px;
	width: 6px;
	height: 6px;
	background-color: #f00;
	border-radius: 3px;
}

.indicatorLight {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  width: 22px;
  border-radius: 11px;
  color: #fff;
}
.notExists {
  background-color: grey;
  border: 2px solid rgb(96, 95, 95);
}
.isActive {
  background-color: green;
  border: 2px solid rgb(0, 101, 0);
}
.isStopped {
  background-color: red;
  border: 2px solid rgb(228, 1, 1);
}
.isStopping {
  background-color: orange;
  border: 2px solid rgb(217, 141, 0);
}

.warning {
  background-color: rgb(239, 239, 223);
}
</style>
